// extracted by mini-css-extract-plugin
export var activeDot = "_30-c";
export var buttonContainer = "_30-9";
export var channelButton = "_30-a";
export var clickable = "_30-d";
export var content = "_30-0";
export var contentFull = "_30-2";
export var contentThird = "_30-1";
export var contentWrapper = "_30-7";
export var description = "_30-5";
export var heightShort = "_30-f";
export var image = "_30-3";
export var imageContainer = "_30-4";
export var selectButton = "_30-e";
export var spinnerContainer = "_30-b";
export var titleContent = "_30-8";
export var titleWrapper = "_30-6";